// Module
var code = "<with-unison> <div class=\"info-toast cu-d-flex cu-justify-content-between cu-align-items-center cu-p-3\"> <cu-icon name=\"lightbulb\"></cu-icon> <div class=\"cu-mx-2\">{{ title }}</div> <cu-icon name=\"close\" ng-click=\"close()\" class=\"close-icon\"></cu-icon> </div> </with-unison> ";
// Exports
module.exports = code;